<template>
  <div class="talent-item-user-info">
    <div>
      <el-image v-if="resData.head_logo" class="re-avatar-img" :src="resData.head_logo" alt="" fit='cover' :class="styleFilSet.img"></el-image>
    </div>
    
    <div class="re-user-more">
      <div class="rum-1">
        <p class="rum-1-name" :style="styleFilSet.name">{{resData.name}}</p>
        <button class="dynamic" v-if="dynamic<=1">今日活跃</button>
        <button class="dynamic" v-else-if="dynamic<=7">本周活跃</button>
        <button class="dynamic" v-else-if="dynamic<=30">月内活跃</button>

      </div>
      <div class="rum-2">
        {{resData.work_age ? `工作${resData.work_age}年` : '无工作经验'}}<span>|</span>{{resData.age}}岁<span>|</span>{{resData.gender ? '男' : '女'}}<span>|</span>{{resData.height}}cm
      </div>
      <div class="rum-3">
        期望城市：{{resData.wanted_city}}
      </div>
      <div class="rum-3">
        求职状态：{{resData.working_state}}
      </div>
      <div style="display:flex;" v-if="wantedHonour">
        <div style="width:100%;display:flex;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
          <button v-for="(item,index) in wantedHonour" :key="index" style="padding:3px 12px;background: #F7AD59;border-radius: 4px;margin-right:10px;color:#fff;font-size:12px">
            {{item}}
          </button>
        </div>
        <span v-if="wantedHonour.length > 3" >...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['resData', 'filSet'],
  computed: {
    wantedHonour(){
      if(this.resData.honour){
        let dom = this.resData.honour
        let a=[]
        for(let i=0;i<dom.length;i++){
          if(dom[i]){
            a.push(...dom[i].split(","))
          }
        }
        return Array.from(new Set(a))
      }
    },
    styleFilSet () {
      if (this.filSet) {
        return {
          name: 'color: transparent;text-shadow: #3C4554 0 0 7px;',
          img: 'fil-img'
        }
      } else {
        return {
          name: '',
          img: ''
        }
      }
    },
    dynamic(){
      let n=new Date();
      let last_visit_time=new Date(this.resData.last_visit_time);
      let res=n.getTime()-last_visit_time.getTime();
      return parseInt(res/(1000*60*60*24))
    }
  },
  mounted(){
  }
}
</script>

<style lang='scss'>
@import '$styles/global.scss';

.talent-item-user-info{
  width:100%;
  // @include flex-box(flex-start);
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;

  .fil-img{
    img{
      filter: blur(5px);
    }
  }

  .re-avatar-img{
    width: 72px;
    height: 72px;
    border-radius: 50%;
    position: relative;
    top: 3px !important;
    border:1px solid #CFD7E1;

    img{
      position: relative;
    }
  }

  .re-user-more{
    width: calc(100% - 92px);
    overflow: hidden;
    margin-left: 20px;

    .rum-1{
      font-size: 16px;
      @include flex-box(flex-start);
      flex-wrap: nowrap;
      .rum-1-name{
        max-width: 100px;
        @include text-ellipsis();
        position: relative;
        font-weight: bold;
      }

      // .rum-1-name::after{
      //   content: "";
      //   width: 100%;
      //   height: 100%;
      //   position: absolute;
      //   left: 0;
      //   top: 0;
      //   background: #FFF;
      //   filter: blur(5px);/*为了模糊更明显，调高模糊度*/
      //   z-index: 10;
      // }

      .rum-1-tag{
        margin-left: 15px;
        .item{
          height: 24px;
          padding: 0 6px;
          line-height: 22px;
          background-color: #fff;
          border-radius: 4px;
          border: 1px solid #F6E9CA;
          color: #888D96;
          font-size: 12px;
          white-space: nowrap;
          display: flex;
        }     
        
      }
    }

    .rum-2{
      margin: 8px 0;
      font-size: 14px;
      color: #888D96;
      span{
        margin: 0 10px;
        color: #D8D8D8;
      }
    }

    .rum-3{
      margin-bottom: 8px;
      font-size: 14px;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #3C4554;
      @include text-ellipsis();
    }
    .dynamic{
      padding: 3px 10px;
      border-radius: 4px;
      border: 1px solid #DAE2EF;
      background-color: #fff;
      font-size: 12px;
      color: #888D96;
      margin-left: 15px;
    }
  }  
}
</style>
